import styled from 'styled-components'

import { Text } from '@interco/inter-ui/components/Text'

export const TagContainer = styled.div`
  margin: 0px -4px;
`

export const Container = styled.button`
  width: 100%;
  margin-top: 16px;
  background-color: var(--neutral-theme);
  cursor: pointer;
  border: 1px solid var(--gray200);
  border-radius: 8px;
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  margin: 0px 8px;
`

export const ServiceButtonContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  padding: 8px;
`

export const DescriptionArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  text-align: start;
  flex: 1;
  gap: 4px;
`

export const ServiceButtonTitle = styled(Text)`
  font-weight: 700 !important;
`

export const UpdateInfo = styled.div`
  background-color: var(--primary500);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-left: 8px;
`
export const TitleContainer = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
`
